export class FlowConstants {
    static readonly VALUE_PLACEHOLDER = '{{value}}';
}
